import { IConfiguredHttp } from './http';

export interface ILoginError {
	errorType: string;
	errorMessage: string;
}

export interface ILoginSuccess {
	ChallengeName?: string;
	Session?: string;
	ChallengeParameters?: { [key: string]: string };
}

export type ILoginResponse = ILoginSuccess | ILoginError;

export interface ISessionsApi {
	login: (username: string) => Promise<ILoginResponse>;
}

const sessionsApiFactory = (http: IConfiguredHttp, prefix = ''): ISessionsApi => ({
	login(email) {
		return http.post(`${prefix}/login`, { email: email.toLowerCase() });
	}
});

export default sessionsApiFactory;
